import React, { Component } from 'react'

import PontoInteresse from './PontoInteresse';

import {Link} from 'react-router-dom';

import { Element } from 'react-scroll';

import PropTypes from 'prop-types';

import axios from 'axios';

export default class PontosInteresse extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    
    this.state = {
      pontosInteresse: []
    }

  }

  componentDidMount = () => {
    this.loadPontosInteresse();
  }

  loadPontosInteresse = async () => {
    
    let res = {};
    try{

      res = await axios.get('api/pontosInteresse', {
        params: {
          'type': 'PONTO_INTERESSE',
          'limit': 4
        },
        headers: {
          'APIKEY': 'q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf',
          'Content-Type': 'application/json'
        }
      });

    } catch(error){
      console.log(error);
    }
    
    let pontosInteresse = res.data.arrayPontos;

    this.setState({pontosInteresse: pontosInteresse});

  }

  pontoClicked = (identifier) => {
    this.context.router.history.push("/pontos_interesse/" + identifier);
  }


  render() {

    const items = this.state.pontosInteresse.map((item, index) => {
      return <PontoInteresse POIClicked={() => this.pontoClicked(item.identifier)} ponto={item} key={item.identifier} number={index}></PontoInteresse>;
    });

    
    return (
      <section id="pontos-interesse">
      <Element name="aldeiaElement"></Element>
        

        <div className="container">
          <p className="section-sub-title">Pontos de Interesse</p>
          {
            items.length === 0 
            
            ? 
              <p>Os pontos de interessa da aldeia encontram-se em reconstrução. Mas vale a pena visitar-nos à mesma.</p>
            :
            <>
            <div className="row">
              {items}
            </div>
            <div className="see-more">
              <Link to={'/pontos_interesse'}>Ver mais<i className="fas fa-angle-right"></i></Link>
            </div>
            </>
          }
          
           
        </div>

        
      </section>
    )
  }
}
